const jobCategories = [
  { value: "", label: "Tất cả loại hình công việc" },
  { value: "Khu CN, Sản xuất, May mặc", label: "Khu CN, Sản xuất, May mặc" },
  { value: "Việc làm phổ thông, Giúp việc", label: "Việc làm phổ thông, Giúp việc" },
  { value: "Lái xe, Phụ xe, Giao hàng", label: "Lái xe, Phụ xe, Giao hàng" },
  { value: "Partime, Sinh viên", label: "Partime, Sinh viên" },
  { value: "Hành chính nhân sự, kế toán, kiểm toán", label: "Hành chính nhân sự, kế toán, kiểm toán" },
  { value: "Quản lý, Kinh doanh, Sale", label: "Quản lý, Kinh doanh, Sale" },
  { value: "CNTT, Kỹ sư, Kỹ thuật", label: "CNTT, Kỹ sư, Kỹ thuật" },
  { value: "Y tế, Dược, Sinh hóa", label: "Y tế, Dược, Sinh hóa" },
  { value: "Xây dựng, Thiết kế, Kiến trúc", label: "Xây dựng, Thiết kế, Kiến trúc" },
  { value: "Dịch vụ, Du lịch, Nhà hàng, Khách sạn", label: "Dịch vụ, Du lịch, Nhà hàng, Khách sạn" },
  { value: "Nông nghiệp, Công nghệ Thực phẩm", label: "Nông nghiệp, Công nghệ Thực phẩm" },
  { value: "Việc online, Chốt đơn, Telesale, Đóng hàng", label: "Việc online, Chốt đơn, Telesale, Đóng hàng" },
  { value: "Freelancer", label: "Freelancer" },
  { value: "Khác", label: "Khác" },
];

const locations = [
  { value: "", label: "Tất cả địa điểm làm việc" },
  { value: "an giang", label: "An Giang" },
  { value: "bắc ninh", label: "Bắc Ninh" },
  { value: "cà mau", label: "Cà Mau" },
  { value: "cao bằng", label: "Cao Bằng" },
  { value: "đăk lawk", label: "Đắk Lắk" },
  { value: "điện biên", label: "Điện Biên" },
  { value: "đồng nai", label: "Đồng Nai" },
  { value: "đồng tháp", label: "Đồng Tháp" },
  { value: "gia lai", label: "Gia Lai" },
  { value: "hà tĩnh", label: "Hà Tĩnh" },
  { value: "hưng yên", label: "Hưng Yên" },
  { value: "khánh hòa", label: "Khánh Hòa" },
  { value: "lai châu", label: "Lai Châu" },
  { value: "lâm đồng", label: "Lâm Đồng" },
  { value: "lạng sơn", label: "Lạng Sơn" },
  { value: "lào cai", label: "Lào Cai" },
  { value: "nghệ an", label: "Nghệ An" },
  { value: "ninh bình", label: "Ninh Bình" },
  { value: "phú thọ", label: "Phú Thọ" },
  { value: "quảng ngãi", label: "Quảng Ngãi" },
  { value: "quang ninh", label: "Quảng Ninh" },
  { value: "quảng trị", label: "Quảng Trị" },
  { value: "sơn la", label: "Sơn La" },
  { value: "tây ninh", label: "Tây Ninh" },
  { value: "thái nguyên", label: "Thái Nguyên" },
  { value: "thanh hóa", label: "Thanh Hóa" },
  { value: "cần thơ", label: "Cần Thơ" },
  { value: "đà nẵng", label: "Đà Nẵng" },
  { value: "hà nội", label: "Hà Nội" },
  { value: "hải phòng", label: "Hải Phòng" },
  { value: "tp. hồ chí minh", label: "TP. Hồ Chí Minh" },
  { value: "huế", label: "Huế" },
  { value: "tuyên quang", label: "Tuyên Quang" },
  { value: "vĩnh long", label: "Vĩnh Long" },
];

interface HeroSectionProps {
  activeCategory: string;
  activeLocation: string;
  searchQuery: string;
  onCategoryChange: (value: string) => void;
  onLocationChange: (value: string) => void;
  onSearchChange: (value: string) => void;
}

export default function HeroSection({
  activeCategory,
  activeLocation,
  searchQuery,
  onCategoryChange,
  onLocationChange,
  onSearchChange,
}: HeroSectionProps) {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20professional%20recruitment%20and%20hiring%20office%20environment%20with%20warm%20ambient%20lighting%2C%20diverse%20team%20collaborating%20in%20bright%20open%20workspace%20with%20abstract%20geometric%20glass%20partitions%2C%20soft%20coral%20beige%20and%20warm%20gray%20tones%2C%20career%20opportunity%20concept%2C%20clean%20minimalist%20aesthetic%2C%20stylized%20editorial%20photography%2C%20uplifting%20atmosphere%2C%20soft%20natural%20light%20streaming%20through%20large%20windows%2C%20modern%20furniture%2C%20positive%20energy%2C%20high%20key%20lighting%2C%20spacious%20airy%20composition%2C%20elegant%20corporate%20yet%20friendly%20vibe&width=1600&height=900&seq=hero-recruitment-v2&orientation=landscape"
          alt="Không gian tuyển dụng chuyên nghiệp, hiện đại"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-10">
        <div className="max-w-4xl mx-auto text-center">
          <span className="inline-block px-3.5 py-1.5 bg-primary-500 text-white text-xs font-semibold rounded-full mb-6 tracking-wide">
            TUYỂN DỤNG MỖI NGÀY
          </span>
          <h1 className="font-heading font-extrabold text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white leading-[1.4] mb-6">
            Việc gì cũng có!
          </h1>
          <p className="text-white/80 text-sm md:text-base mb-8 max-w-xl mx-auto">
            Hàng ngàn việc làm mới mỗi ngày từ các công ty uy tín. Tìm việc nhanh, ứng tuyển dễ.
          </p>

          {/* Search bar */}
          <div className="relative max-w-xl mx-auto mb-5">
            <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-white/85 text-sm pointer-events-none z-10"></i>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder="Tìm kiếm việc làm, công ty..."
              className="w-full pl-11 pr-10 py-3 text-sm bg-white/15 backdrop-blur-sm border border-white/25 rounded-full focus:outline-none focus:border-white/50 focus:bg-white/25 transition-all text-white placeholder:text-white/50"
            />
            {searchQuery && (
              <button
                onClick={() => onSearchChange("")}
                className="absolute right-4 top-1/2 -translate-y-1/2 text-white/70 hover:text-white transition-colors cursor-pointer"
                aria-label="Xóa tìm kiếm"
              >
                <i className="ri-close-circle-line text-base"></i>
              </button>
            )}
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-xl mx-auto">
            <div className="relative flex-1 w-full sm:max-w-[300px]">
              <i className="ri-briefcase-4-line absolute left-4 top-1/2 -translate-y-1/2 text-white/85 text-sm pointer-events-none z-10"></i>
              <select
                value={activeCategory}
                onChange={(e) => onCategoryChange(e.target.value)}
                className="w-full pl-11 pr-9 py-3 text-sm bg-white/15 backdrop-blur-sm border border-white/25 rounded-full focus:outline-none focus:border-white/50 focus:bg-white/25 transition-all text-white appearance-none cursor-pointer"
              >
                {jobCategories.map((c) => (
                  <option key={c.value} value={c.value} className="text-foreground-800">
                    {c.label}
                  </option>
                ))}
              </select>
              <i className="ri-arrow-down-s-line absolute right-4 top-1/2 -translate-y-1/2 text-white/85 text-sm pointer-events-none"></i>
            </div>

            <div className="relative flex-1 w-full sm:max-w-[300px]">
              <i className="ri-map-pin-line absolute left-4 top-1/2 -translate-y-1/2 text-white/85 text-sm pointer-events-none z-10"></i>
              <select
                value={activeLocation}
                onChange={(e) => onLocationChange(e.target.value)}
                className="w-full pl-11 pr-9 py-3 text-sm bg-white/15 backdrop-blur-sm border border-white/25 rounded-full focus:outline-none focus:border-white/50 focus:bg-white/25 transition-all text-white appearance-none cursor-pointer"
              >
                {locations.map((l) => (
                  <option key={l.value} value={l.value} className="text-foreground-800">
                    {l.label}
                  </option>
                ))}
              </select>
              <i className="ri-arrow-down-s-line absolute right-4 top-1/2 -translate-y-1/2 text-white/85 text-sm pointer-events-none"></i>
            </div>
          </div>

          <div className="flex items-center justify-center gap-6 mt-10">
            <div className="text-center">
              <p className="text-white font-bold text-xl">12.000+</p>
              <p className="text-white/85 text-xs">Việc làm</p>
            </div>
            <div className="w-px h-8 bg-white/25"></div>
            <div className="text-center">
              <p className="text-white font-bold text-xl">3.500+</p>
              <p className="text-white/85 text-xs">Công ty</p>
            </div>
            <div className="w-px h-8 bg-white/25"></div>
            <div className="text-center">
              <p className="text-white font-bold text-xl">34</p>
              <p className="text-white/85 text-xs">Tỉnh thành</p>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-background-50 to-transparent z-10"></div>
    </section>
  );
}